import { Box, Typography } from "@mui/material";

export default function ShippingInformation(props) {
  const { shippingData } = props;

  if (!shippingData) return <></>

  const { carriers, errors } = shippingData?.retrieveShippingQuote;

  if (!carriers) return <></>

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });


  const workingCarriers = carriers.filter((carrier) => !carrier.error);

  if (errors || workingCarriers.length === 0) return <>
    <Box
      key={'error'}
      sx={{
        marginY: 2
      }}
    >
      <Typography component='strong' fontSize={'24px !important'} sx={{
        fontWeight: 'bold',
      }}>{errors ?? 'Shipping not available'}</Typography>
    </Box>
  </>


  return (
    <>
      {workingCarriers?.map((carrier) => (
        <Box
          key={carrier.carrierCode}
          sx={{
            marginY: 2
          }}
        >
          <Typography component='strong' fontSize={'24px !important'} sx={{
            fontWeight: 'bold',
          }}>{carrier?.carrierTitle} - {formatter.format(carrier?.shippingRates?.[0]?.totalCharges ?? 0)}</Typography>
          <Typography component='p'>{carrier?.shippingRates?.[0]?.title}</Typography>
        </Box>
      ))}
    </>
  );
}